import React, { Component } from 'react'

import {connect} from 'react-redux';

import './overLayLoader.css';

class OverLayLoader extends Component {
  render() {
    const { userListLoading, paAnaTeamListLoading, assessorGroupsLoading } = this.props
    return (
      <div className={userListLoading || paAnaTeamListLoading || assessorGroupsLoading ? "overlayEffect" : ""} >
        {this.props.children}
      </div>
    )
  }
}

const mapStateToProps = state => {
    return {
        userListLoading: state.userListReducer.userListLoading, 
        paAnaTeamListLoading: state.getPaAnanlyzeTeamListReducer.paAnaTeamListLoading, 
        assessorGroupsLoading: state.assessorGroupsReducer.assessorGroupsLoading
    }
}

export default connect(mapStateToProps)(OverLayLoader)


// WEBPACK FOOTER //
// ./src/_pages/Organzation/Analyze/overLayLoader.js